module.exports = __webpack_public_path__ + "img/marcador.9ea7368b.png";